import React, { useContext, useEffect, useState } from 'react';
import {
  PreviewContainer,
  TabsContainer,
  View,
  TabsContent,
  EditorWrapper,
  EditingContainer,
} from '../styles';
import {
  GridContainer,
  PinNavBar,
  GridItem,
  DownloadButton,
} from '../../../containers/TopMenu/styles';
import { Icon, Select, message, Tooltip } from 'antd';
import { shortMsgTextToJson } from '../../../utils/JsonConversion/node2Json';
import { ShortMsgTextContext } from '../../../context/shortMessageContext';
import { AppStoreContext } from '../../../context/appStoreContext'; 
import ShortMessageEditingArea from './EditingArea';
import { ShortMsgCheckIcon } from '../../../images/svgIcons';
import WhatsAppTick from '../../../images/whatsapp-tick.png';
import SendTestMessageModal from '../PublishCycle/SendTestMessageModal';
import { updateTemplate, getAudio } from '../../../utils/services/shortMessageTemplateAPI';
import { useTranslation } from 'react-i18next';
import { SHORT_MESSAGE_CHANNELS } from './translationValues';
import { IS_WHATSAPP_ENABLED } from '../../../utils/helper';

const NAMESPACES = ['SHORT_MESSAGE_CHANNELS'];
const { Option } = Select;

/* This component contains the channels switching tabs and its individual editing area
  Child Components: 
    * ShortMessageEditingArea
    * SendTestMessageModal
*/

const ShortMessageChannels = props => {
  const {
    shortMsgContent,
    tabIndex,
    voicesList,
    variableList,
    showVersions,
    availableChannels,
    updateDocumentVariables,
    isPreview,
    currentPriviewTab,
    shortMsgPreviewContent,
    nonDraftVoice,
  } = props;
  const { t } = useTranslation(NAMESPACES);
  const [activeTabs, setActiveTabs] = useState([0, 1, 2]);
  const [isPlay, setPlay] = useState(false);
  const [tabs,setTabs] = useState([true, true, true]);
  const [audio, setAudio] = useState(undefined);
  const [isConvertingText, setIsConvertingText] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const [disablePlayBtn, setDisablePlayBtn] = useState(false);
  const [inputChanged, setIsInputChanged] = useState(false);
  const [saveChanges, setSaveChanges] = useState(false);
  const [audioOfEnv, setAudioOfEnv] = useState(undefined);
  const {
    focusedEditor,
    tempDetails,
    setTempDetails,
    setFocusedEditor,
    voiceName,
    setVoiceName,
    whatsappLength,
    setWhatsappLength,
    messageLength,
    setMessageLength,
    callLength,
    setCallLength,
    setIsDraft,
    currentEnv,
  } = useContext(ShortMsgTextContext);
  const { globalVariables, updateGlobalVariables } = useContext(AppStoreContext);
  let shortMsgText = isPreview
    ? shortMsgPreviewContent?.shortMessageText
    : shortMsgContent?.shortMessageText;

  useEffect(() => {
    changePosition(tabs);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (audio && audioOfEnv === currentEnv) {
      setPlay(true);
      let newAudio = audio;
      !disablePlayBtn && newAudio.play();
      newAudio.onended = () => {
        setPlay(false);
      };
    } else if (audioOfEnv !== currentEnv) {
      setAudio(undefined);
    }
    // eslint-disable-next-line
  }, [audio]);

  useEffect(() => {
    if (audio) {
      setIsConvertingText(false);
      setPlay(false);
      audio.pause();
      audio.currentTime = 0;
    }
    // eslint-disable-next-line
  }, [currentEnv]);

  useEffect(() => {
    if (showVersions) {
      let updateTabs = [false, false, false];
      availableChannels.forEach(i => updateTabs[i] = !updateTabs[i]);
      setTabs(updateTabs);
      setActiveTabs(availableChannels);
      changePosition(updateTabs);
    } else {
      setTabs([true, true, true]);
      setActiveTabs([0, 1, 2]);
      changePosition([true, true, true]);
    }
    // eslint-disable-next-line
  }, [availableChannels, shortMsgContent, showVersions]);

  useEffect(() => {
    if (shortMsgContent) {
      let tempDetails = {
        id: shortMsgContent.id,
        name: shortMsgContent.name,
        groupId: shortMsgContent.groupId,
        language: shortMsgContent.language,
        tags: shortMsgContent.tags,
        messageId: shortMsgContent.messageId,
        categoryId: shortMsgContent.categoryId,
        resourceGroupId: shortMsgContent.resourceGroupId,
        communicationId: shortMsgContent.communicationId
      };
      setAudio(undefined);
      setTempDetails(tempDetails);
    }
    // eslint-disable-next-line
  }, [shortMsgContent]);

  const onEditorFocus = e => {
    setFocusedEditor(e);
  };

  const updateShortMsgContent = async (
    htmlData,
    channel,
    selectedVoice = undefined,
    isUnsavedChanges,
  ) => {
    const jsonData = await shortMsgTextToJson(htmlData);
    if (jsonData) {
      updateRespMessage('loading');
      let messageType =
        channel === 'Whatsapp'
          ? 'whatsapp'
          : channel === 'Message'
          ? 'sms'
          : channel === 'call'
          ? 'call'
          : '';
      let payload = {
        id: tempDetails?.id,
        name: tempDetails?.name,
      };
      payload[messageType] = jsonData;
      if (channel === 'call') {
        setDisablePlayBtn(true);
        setAudio(undefined);
        payload.voiceName = selectedVoice || voiceName;
      }
      updateRespMessage('loading', channel);
      let templateResponse = await updateTemplate(payload, messageType);
      if (templateResponse) {
        setDisablePlayBtn(false);
        if (templateResponse?.statusCode === 9999) {
          updateRespMessage('error', channel);
        } else if (templateResponse.errors && templateResponse.errors.length === 0) {
          setIsDraft(true);
          updateRespMessage('success', channel);
          if (channel === 'call' && isUnsavedChanges) {
            setSaveChanges(true);
            setIsInputChanged(false);
            setPlay(true);
            handlePlayPauseAudio(undefined, true);
            setTimeout(() => {
              setSaveChanges(false);
            }, 10);
          }
        } else {
          updateRespMessage('error', channel);
        }
      }
    }
  };

  const updateRespMessage = (respType, type) => {
    if (respType) {
      let messageType =
        type === 'Whatsapp'
          ? t(
              SHORT_MESSAGE_CHANNELS.WHATSAPP_CHANNEL_MESSAGE.key,
              SHORT_MESSAGE_CHANNELS.WHATSAPP_CHANNEL_MESSAGE.value,
            )
          : type === 'Message'
          ? t(
              SHORT_MESSAGE_CHANNELS.SMS_CHANNEL_MESSAGE.key,
              SHORT_MESSAGE_CHANNELS.SMS_CHANNEL_MESSAGE.value,
            )
          : type === 'call'
          ? t(
              SHORT_MESSAGE_CHANNELS.VOICE_CHANNEL_MESSAGE.key,
              SHORT_MESSAGE_CHANNELS.VOICE_CHANNEL_MESSAGE.value,
            )
          : '';
      message[respType](
        <div
          style={{
            display: 'inline-flex',
            fontSize: '14px',
          }}
        >
          {respType === 'loading'
            ? t(
                SHORT_MESSAGE_CHANNELS.UPDATING_CHANNEL_MESSAGE.key,
                SHORT_MESSAGE_CHANNELS.UPDATING_CHANNEL_MESSAGE.value,
              ) +
              ' ' +
              messageType
            : respType === 'success'
            ? messageType +
              ' ' +
              t(
                SHORT_MESSAGE_CHANNELS.CHANNEL_UPDATED_SUCCESS_MESSAGE.key,
                SHORT_MESSAGE_CHANNELS.CHANNEL_UPDATED_SUCCESS_MESSAGE.value,
              )
            : respType === 'error'
            ? t(
                SHORT_MESSAGE_CHANNELS.UNABLE_TO_UPDATE_CHANNEL_ERROR_MESSAGE.key,
                SHORT_MESSAGE_CHANNELS.UNABLE_TO_UPDATE_CHANNEL_ERROR_MESSAGE.value,
              ) +
              ' ' +
              messageType
            : ''}
        </div>,
        respType === 'loading' ? 0 : 2,
      );
    }
  };

  const handlePlayPauseAudio = async (audio, isPlayAudio, env) => {
    if (audio) {
      isPlayAudio ? audio.play() : audio.pause();
      audio.onended = () => {
        setPlay(false);
      };
    } else {
      if (tempDetails?.id && callLength !== 0) {
        setIsConvertingText(true);
        const audioPayload = {
          voiceName: showVersions ? nonDraftVoice : voiceName,
          messageId: tempDetails?.messageId || tempDetails?.id,
          env:
            currentEnv === 'testing' ? 'qaready' : currentEnv === 'publish' ? 'published' : 'draft',
        };
        let audioResponse = await getAudio(audioPayload);
        if (audioResponse) {
          setIsConvertingText(false);
          let newAudio = new Audio(audioResponse);
          setAudio(newAudio);
        }
      } else {
        setPlay(false);
        message.error(
          t(
            SHORT_MESSAGE_CHANNELS.EMPTY_VOICE_CHANNEL_INPUT_ERROR_MESSAGE.key,
            SHORT_MESSAGE_CHANNELS.EMPTY_VOICE_CHANNEL_INPUT_ERROR_MESSAGE.value,
          ),
        );
      }
    }
  };

  const onVoiceChange = (e, editorID, isUnsavedChanges = false) => {
    setVoiceName(e);
    let element = document?.getElementsByClassName(`ql-editor-area-${editorID}`);
    if (element?.length > 0) {
      let htmlText = element[0].getElementsByClassName(`ql-editor`);
      updateShortMsgContent(htmlText[0].childNodes, 'call', e, isUnsavedChanges);
    }
  };

  const renderTabs = (channel, tabID) => {
    if(tabID === 0 && !IS_WHATSAPP_ENABLED) return null;
    return (
      <div className="Tabs" onClick={() => toggleChannels(tabID)}>
        {channel}
        {activeTabs.includes(tabID) && (
          <div className="Check">
            <Icon component={ShortMsgCheckIcon} />
          </div>
        )}
      </div>
    );
  };

  const toggleChannels = tabID => {   
    let value;
    value = !tabs[tabID];
    tabs[tabID] = value;
    setTabs(tabs)
    if (activeTabs.includes(tabID)) {
      let newVar = activeTabs.filter(value => value !== tabID);
      setActiveTabs(newVar);
    } else {
      setActiveTabs([...activeTabs, tabID]);
    }
    changePosition(tabs);  
  };

  const changePosition = (tabs) => {
    let numSelected = tabs.reduce((p, c) => (c ? Number(p) + 1 : Number(p)));
    numSelected = IS_WHATSAPP_ENABLED || showVersions ? numSelected : parseInt(numSelected)-1;
    document.querySelector('.div-section').style = '--num-selected: ' + numSelected;
    let divs = document.querySelectorAll('[data-div]');
    let place = 1;
    for (let i = 0; i < divs.length; i++) {
      const div = divs[i];
      div.setAttribute('data-selected', IS_WHATSAPP_ENABLED ? tabs[i] : tabs[i+1]);
      div.style = `--place: ${tabs[IS_WHATSAPP_ENABLED ? i : i + 1] ? place : i + 1}`;
      if (tabs[IS_WHATSAPP_ENABLED ? i : i+1]) {
        place++;
      }
    }
  };

  const renderChannels = (channel, tabID, displayText) => {
    if(tabID === 0 && !IS_WHATSAPP_ENABLED) return null;
    let time = new Date();
    let h = time.getHours();
    let hour = h > 12 ? h % 12 : h;
    let m = time.getMinutes();
    let mins = m < 10 ? '0' + m : m;
    let session = h >= 12 ? 'PM' : 'AM';
    const currentTime = hour + ':' + mins + ' ' + session;
    return (
      <View
        active={tabID}
        data-div={tabID}
        popupPreview={isPreview}
        showVersions={showVersions}
        className={isPreview ? 'popup-section-divs disable-pointer-events' : showVersions ? 'section-divs disable-pointer-events' : 'section-divs'}
      >
        {tabID <= 1 ? (
          <div className={`${tabID === 0 ? 'Phone' : tabID === 1 ? 'Phone Messages' : ''}`}>
            <div className="Features-Top"></div>
            <div className="Screen">
              <div className="Header">
                <i className="fa-solid fa-arrow-left"></i>
                <div className="Contact">{displayText}</div>
                {tabID === 0 && <i className="fa-solid fa-video"></i>}
                <i className="fa-solid fa-phone"></i>
                <i className="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div className="Main">
                <div className="MessageContainer">
                  {tabID === 0 && (
                    <div className="Today">
                      <p>
                        {t(
                          SHORT_MESSAGE_CHANNELS.CHANNEL_CURRENT_DAY.key,
                          SHORT_MESSAGE_CHANNELS.CHANNEL_CURRENT_DAY.value,
                        )}
                      </p>
                    </div>
                  )}
                  <div className="Message" onClick={() => onEditorFocus(tabID)}>
                    {editingArea(
                      tabID === 0
                        ? shortMsgText?.whatsapp
                        : tabID === 1
                        ? shortMsgText?.sms
                        : tabID === 2
                        ? shortMsgText?.call
                        : '',
                      channel,
                      '',
                      tabID === 1 ? 256 : null,
                      tabID,
                    )}
                    {tabID === 0 && <img src={WhatsAppTick} className="Tick" />}
                    <span className="Time">
                      {currentTime}
                      {tabID === 1 &&
                        t(
                          SHORT_MESSAGE_CHANNELS.WHATSAPP_MESSAGE_SEEN_BY_USER.key,
                          SHORT_MESSAGE_CHANNELS.WHATSAPP_MESSAGE_SEEN_BY_USER.value,
                        )}
                    </span>
                  </div>
                </div>
                {!showVersions &&
                  !isPreview &&
                  tabID > 0 &&
                  focusedEditor === tabID &&
                  renderMaxCount(channel)}
              </div>
            </div>
            <div className="Bottom">
              <div className="Button">
                <div className="Square"></div>
              </div>
            </div>
          </div>
        ) : (
          renderVoiceChannel(tabID, channel)
        )}
      </View>
    );
  };

  const editingArea = (text, channel, placeHolder = '', maxCharLength, tabID) => {
    let htmlShortMsgText = '';
    let dummyVal = text?.length > 0 ? text?.forEach(ele => (htmlShortMsgText += `${ele}`)) : '';
    return (
      <EditorWrapper messageStudio={true}>
        <EditingContainer messageStudio={true} isCall={tabID === 2}>
          <ShortMessageEditingArea
            shortMsgText={text?.length > 0 ? htmlShortMsgText : ''}
            editorId={tabID}
            updateShortMsgContent={html => updateShortMsgContent(html, channel)}
            onEditorFocus={e => onEditorFocus(e)}
            placeHolder={placeHolder}
            maxCharLength={maxCharLength}
            changeCount={(len, isInputChanged) => changeAvlCount(len, isInputChanged, channel)}
            updateDocumentVariables={e => !isPreview && updateDocumentVariables(e, channel)}
            quillEnabled={isPreview ? false : !showVersions}
            saveChanges={saveChanges}
            showVersions={showVersions}
            globalVariables={globalVariables} 
            updateGlobalVariables={updateGlobalVariables}
          />
        </EditingContainer>
      </EditorWrapper>
    );
  };

  const renderVoiceChannel = (tabID, channel) => {
    return (
      <section className="Voice-Message" onClick={() => onEditorFocus(tabID)}>
        <p className="title">
          {t(
            SHORT_MESSAGE_CHANNELS.VOICE_MESSAGE_CHANNEL_NAME.key,
            SHORT_MESSAGE_CHANNELS.VOICE_MESSAGE_CHANNEL_NAME.value,
          )}
        </p>
        <div className={`call-container`} data-channel={'call'}>
          <div className={`selectable-call`}>
            {editingArea(
              shortMsgText?.call,
              'call',
              t(
                SHORT_MESSAGE_CHANNELS.VOICE_MESSAGE_CHANNEL_PLACEHOLDER.key,
                SHORT_MESSAGE_CHANNELS.VOICE_MESSAGE_CHANNEL_PLACEHOLDER.value,
              ),
              1500,
              tabID,
            )}
          </div>
        </div>
        {!isPreview && (
          <div className="Voice-Msg-Footer">
            <div className="Voice-Msg-Footer-Div">
              <button
                className={(disablePlayBtn || showVersions) && 'disabled'}
                onClick={
                  disablePlayBtn || isConvertingText
                    ? ''
                    : () => {
                        setAudioOfEnv(currentEnv);
                        if (inputChanged) {
                          setPlay(!isPlay);
                          if (audio) {
                            audio.pause();
                            audio.currentTime = 0;
                          }
                          onVoiceChange(voiceName, 2, true);
                        } else {
                          setPlay(!isPlay);
                          handlePlayPauseAudio(audio, !isPlay);
                        }
                      }
                }
              >
                {!disablePlayBtn && isConvertingText && audioOfEnv === currentEnv ? (
                  <Icon type="loading" />
                ) : audioOfEnv !== currentEnv ? (
                  <i className={'fa-solid fa-play'} />
                ) : (
                  <i
                    className={!disablePlayBtn && isPlay ? 'fa-solid fa-pause' : 'fa-solid fa-play'}
                  >
                    <span className={!disablePlayBtn && isPlay ? 'playing' : ''}></span>
                  </i>
                )}
              </button>
              <Select
                onChange={e => onVoiceChange(e, tabID)}
                disabled={isPlay || showVersions}
                value={showVersions ? nonDraftVoice : voiceName}
                className="Voice-Option"
                showArrow={!showVersions}
              >
                {voicesList?.length > 0 &&
                  voicesList?.map(voice => {
                    return (
                      <Option
                        value={voice.voiceName}
                      >{`${voice.voiceName}: ${voice.gender}`}</Option>
                    );
                  })}
              </Select>
              {!showVersions &&
                !isPreview &&
                tabID > 0 &&
                focusedEditor === tabID &&
                renderMaxCount(channel)}
            </div>
          </div>
        )}
      </section>
    );
  };

  const changeAvlCount = (avlCount, isInputChanged, channel) => {
    setIsInputChanged(isInputChanged);
    let channelsTextLength = parseInt(avlCount);
    if (channel === 'Whatsapp') setWhatsappLength(channelsTextLength);
    if (channel === 'Message') setMessageLength(channelsTextLength);
    if (channel === 'call') setCallLength(channelsTextLength);
  };

  const renderMaxCount = channel => {
    return (
      <div className="charLimit">
        <span>{t(SHORT_MESSAGE_CHANNELS.MAXIMUM_ALLOWED_CHARACTERS_MESSAGE.key, SHORT_MESSAGE_CHANNELS.MAXIMUM_ALLOWED_CHARACTERS_MESSAGE.value, { maxChar: channel === 'call' ? '1500' : '256'})}</span>
        <span className="maxLength">
          {channel === 'Whatsapp'
            ? whatsappLength
            : channel === 'Message'
            ? messageLength
            : channel === 'call'
            ? callLength
            : ''}
          / {channel === 'call' ? '1500' : '256'}
        </span>
      </div>
    );
  };

  return (
    <React.Fragment>
      {isPreview ? (
        renderChannels(
          currentPriviewTab === 0
            ? 'WhatsApp'
            : currentPriviewTab === 1
            ? 'Message'
            : currentPriviewTab === 2
            ? 'call'
            : '',
          currentPriviewTab,
        )
      ) : (
        <>
          <PreviewContainer showVersions={showVersions} isSideBar={tabIndex >= 0 ? true : false}>
            {!showVersions && (
              <TabsContainer tabsWidth={IS_WHATSAPP_ENABLED ? 3 : 2}>
                { renderTabs(
                  t(
                    SHORT_MESSAGE_CHANNELS.WHATSAPP_MESSAGE_CHANNEL_TAB_NAME.key,
                    SHORT_MESSAGE_CHANNELS.WHATSAPP_MESSAGE_CHANNEL_TAB_NAME.value,
                  ),
                  0,
                )}
                {renderTabs(
                  t(
                    SHORT_MESSAGE_CHANNELS.SMS_CHANNEL_TAB_NAME.key,
                    SHORT_MESSAGE_CHANNELS.SMS_CHANNEL_TAB_NAME.value,
                  ),
                  1,
                )}
                {renderTabs(
                  t(
                    SHORT_MESSAGE_CHANNELS.VOICE_MESSAGE_CHANNEL_TAB_NAME.key,
                    SHORT_MESSAGE_CHANNELS.VOICE_MESSAGE_CHANNEL_TAB_NAME.value,
                  ),
                  2,
                )}
              </TabsContainer>
            )}
            <TabsContent
              showVersions={showVersions}
              className="div-section"
              isSideBar={tabIndex >= 0}
            >
              {renderChannels(
                'Whatsapp',
                0,
                t(
                  SHORT_MESSAGE_CHANNELS.WHATSAPP_MESSAGE_CHANNEL_NAME.key,
                  SHORT_MESSAGE_CHANNELS.WHATSAPP_MESSAGE_CHANNEL_NAME.value,
                ),
              )}
              {renderChannels('Message', 1, 'SMS')}
              {renderChannels(
                'call',
                2,
                t(
                  SHORT_MESSAGE_CHANNELS.VOICE_MESSAGE_CHANNEL_NAME.key,
                  SHORT_MESSAGE_CHANNELS.VOICE_MESSAGE_CHANNEL_NAME.value,
                ),
              )}
            </TabsContent>
          </PreviewContainer>

            <GridContainer
              messageStudio={true}
              className={isPinned ? 'mailTemp enable visible' : 'mailTemp enable'}
            >
              <PinNavBar>
                <div>
                  <span className={isPinned ? 'pinned' : ''} onClick={() => setIsPinned(!isPinned)}>
                    <svg viewBox="0 0 32 32">
                      <g id="surface1">
                        <path
                          style={{}}
                          d="M 20.53125 2.5625 L 19.84375 3.5 L 14.9375 10.1875 C 12.308594 9.730469 9.527344 10.472656 7.5 12.5 L 6.78125 13.1875 L 12.09375 18.5 L 4 26.59375 L 4 28 L 5.40625 28 L 13.5 19.90625 L 18.8125 25.21875 L 19.5 24.5 C 21.527344 22.472656 22.269531 19.691406 21.8125 17.0625 L 28.5 12.15625 L 29.4375 11.46875 Z M 20.78125 5.625 L 26.375 11.21875 L 20.15625 15.78125 L 19.59375 16.1875 L 19.78125 16.84375 C 20.261719 18.675781 19.738281 20.585938 18.59375 22.1875 L 9.8125 13.40625 C 11.414063 12.261719 13.324219 11.738281 15.15625 12.21875 L 15.8125 12.40625 L 16.21875 11.84375 Z "
                        />
                      </g>
                    </svg>
                  </span>
                </div>
              </PinNavBar>
              <GridItem>
                <Tooltip
                  placement="top"
                  title={t(
                    SHORT_MESSAGE_CHANNELS.SEND_TEST_MESSAGE_TOOLTIP.key,
                    SHORT_MESSAGE_CHANNELS.SEND_TEST_MESSAGE_TOOLTIP.value,
                  )}
                >
                  <DownloadButton
                    type="primary"
                    icon="mail"
                    size="large"
                    onClick={() => {
                      whatsappLength === 0 && messageLength === 0 && callLength === 0
                        ? message.error(
                          t(
                            SHORT_MESSAGE_CHANNELS.EMPTY_CHANNELS_INPUT_ERROR_MESSAGE.key,
                            SHORT_MESSAGE_CHANNELS.EMPTY_CHANNELS_INPUT_ERROR_MESSAGE.value,
                          ),
                        )
                        : setShowModal(true);
                    }}
                  >
                    {t(
                      SHORT_MESSAGE_CHANNELS.SEND_TEST_MESSAGE_BUTTON.key,
                      SHORT_MESSAGE_CHANNELS.SEND_TEST_MESSAGE_BUTTON.value,
                    )}
                  </DownloadButton>
                </Tooltip>
              </GridItem>
              {showModal && (
                <SendTestMessageModal
                  isWhatsappEmpty={whatsappLength === 0}
                  isSMSEmpty={messageLength === 0}
                  isCallEmpty={callLength === 0}
                  onCancel={() => setShowModal(false)}
                  tempDetails={tempDetails}
                  variableList={variableList}
                  currentEnv={currentEnv}
                />
              )}
            </GridContainer>
        </>
      )}
    </React.Fragment>
  );
};

export default ShortMessageChannels;
